/* NUITAINE — bascule Jour/Nuit, ciel étoilé, galerie, variantes, quantité */
(function () {
  'use strict';

  /* ---------- bascule Jour / Nuit ---------- */
  var root = document.documentElement;
  var btn = document.getElementById('nui-toggle');

  function isNight() { return root.getAttribute('data-theme') === 'nuit'; }
  function syncToggle() {
    if (!btn) return;
    btn.setAttribute('aria-pressed', isNight() ? 'true' : 'false');
  }
  if (btn) {
    var themingTimer;
    var applyTheme = function () {
      var next = isNight() ? 'jour' : 'nuit';
      if (next === 'nuit') root.setAttribute('data-theme', 'nuit');
      else root.removeAttribute('data-theme');
      try { localStorage.setItem('nuitaine-theme', next); } catch (e) {}
      syncToggle();
    };
    btn.addEventListener('click', function () {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        applyTheme();
        return;
      }
      /* fondu d'écran natif : une seule animation GPU, fluide sur mobile */
      if (document.startViewTransition) {
        document.startViewTransition(applyTheme);
        return;
      }
      /* repli : transitions CSS globales le temps du basculement */
      root.classList.add('nui-theming');
      clearTimeout(themingTimer);
      themingTimer = setTimeout(function () { root.classList.remove('nui-theming'); }, 900);
      applyTheme();
    });
    syncToggle();
  }

  /* ---------- ciel étoilé ---------- */
  var canvas = document.getElementById('nui-stars');
  if (canvas) {
    var ctx = canvas.getContext('2d');
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var stars = [], lastW = -1, lastH = -1, timer;

    function seed() {
      var dpr = window.devicePixelRatio || 1;
      var w = canvas.clientWidth, h = canvas.clientHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(w * h / 9000);
      stars = [];
      for (var i = 0; i < n; i++) {
        stars.push({
          x: Math.random() * w, y: Math.random() * h,
          r: Math.random() * 1.3 + 0.4,
          base: Math.random() * 0.45 + 0.25,
          sp: Math.random() * 0.0009 + 0.0003,
          ph: Math.random() * Math.PI * 2,
          warm: Math.random() > 0.82
        });
      }
    }
    function paint(t) {
      ctx.clearRect(0, 0, canvas.clientWidth, canvas.clientHeight);
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        var a = calm ? s.base : s.base + Math.sin(t * s.sp + s.ph) * 0.22;
        if (a < 0.04) a = 0.04;
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fillStyle = s.warm ? 'rgba(196,166,160,' + a + ')' : 'rgba(237,231,225,' + a + ')';
        ctx.fill();
      }
    }
    /* la boucle ne tourne que si le ciel est visible : mode nuit + onglet actif */
    var rafId = null;
    function loop(t) { paint(t); rafId = requestAnimationFrame(loop); }
    function skyStart() {
      if (calm || rafId !== null || document.hidden) return;
      if (root.getAttribute('data-theme') !== 'nuit') return;
      rafId = requestAnimationFrame(loop);
    }
    function skyStop() {
      if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
    }
    function reseed() {
      var w = canvas.clientWidth, h = canvas.clientHeight;
      if (!w || !h || (w === lastW && h === lastH)) return;
      lastW = w; lastH = h; seed(); paint(0);
    }
    if (window.ResizeObserver) {
      new ResizeObserver(function () { clearTimeout(timer); timer = setTimeout(reseed, 150); }).observe(canvas);
    } else {
      window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(reseed, 150); });
    }
    reseed();
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (root.getAttribute('data-theme') === 'nuit') skyStart(); else skyStop();
      }).observe(root, { attributes: true, attributeFilter: ['data-theme'] });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) skyStop(); else skyStart();
    });
    skyStart();
  }

  /* ---------- galerie produit ---------- */
  document.querySelectorAll('[data-nui-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-nui-gallery-main] img');
    gallery.querySelectorAll('[data-nui-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        var img = thumb.querySelector('img');
        if (!img) return;
        main.src = img.dataset.full || img.src;
        main.alt = img.alt;
        gallery.querySelectorAll('[data-nui-thumb]').forEach(function (t) { t.removeAttribute('aria-current'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---------- loupe façon marketplace : le zoom suit la souris ---------- */
  if (!window.matchMedia('(hover: none)').matches) {
    document.querySelectorAll('[data-nui-gallery-main]').forEach(function (frame) {
      var img = frame.querySelector('img');
      if (!img) return;
      frame.addEventListener('mousemove', function (e) {
        var r = frame.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });
      frame.addEventListener('mouseenter', function () { img.style.transform = 'scale(2)'; });
      frame.addEventListener('mouseleave', function () {
        img.style.transform = '';
        img.style.transformOrigin = '';
      });
    });
  }

  /* ---------- sélecteur de variantes ---------- */
  document.querySelectorAll('[data-nui-product]').forEach(function (el) {
    var dataEl = el.querySelector('[data-nui-variants]');
    if (!dataEl) return;
    if (!el.querySelector('[data-nui-option]')) return; /* produit sans déclinaisons : le formulaire natif suffit */
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = el.querySelector('[data-nui-id]');
    var priceEl = el.querySelector('[data-nui-price]');
    var buyBtn = el.querySelector('[data-nui-buy]');
    var stickyPrice = el.querySelector('[data-nui-price-sticky]');
    var stickyBuy = el.querySelector('[data-nui-buy-sticky]');
    var mainImg = el.querySelector('[data-nui-gallery-main] img');
    var labels = el.querySelectorAll('[data-nui-optvalue]');

    function selectedOptions() {
      var opts = [];
      el.querySelectorAll('[data-nui-option]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }
    function money(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
    function refreshAvailability() {
      /* grise, façon marketplace, toute valeur sans variante disponible
         compte tenu des autres options sélectionnées */
      var opts = selectedOptions();
      el.querySelectorAll('[data-nui-option]').forEach(function (group, gi) {
        group.querySelectorAll('input').forEach(function (input) {
          var test = opts.slice();
          test[gi] = input.value;
          var m = variants.find(function (v) {
            return v.options.every(function (o, i) { return o === test[i]; });
          });
          var off = !m || !m.available;
          var lbl = group.querySelector('label[for="' + input.id + '"]');
          if (lbl) lbl.classList.toggle('nui-off', off);
          input.setAttribute('aria-disabled', off ? 'true' : 'false');
        });
      });
    }
    function update() {
      var opts = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      labels.forEach(function (l, i) { if (opts[i]) l.textContent = opts[i]; });
      refreshAvailability();
      if (!match) {
        if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = 'Indisponible'; }
        if (stickyBuy) { stickyBuy.disabled = true; stickyBuy.textContent = 'Indisponible'; }
        el.classList.add('nui-unavailable');
        return;
      }
      var priceText = match.price_formatted || money(match.price);
      var buyText = match.available ? 'Ajouter au panier' : 'Épuisé';
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = priceText;
      if (stickyPrice) stickyPrice.textContent = priceText;
      if (buyBtn) { buyBtn.disabled = !match.available; buyBtn.textContent = buyText; }
      if (stickyBuy) { stickyBuy.disabled = !match.available; stickyBuy.textContent = buyText; }
      el.classList.toggle('nui-unavailable', !match.available);
      if (mainImg && match.featured_image && match.featured_image.src) {
        mainImg.src = match.featured_image.src;
        mainImg.removeAttribute('srcset');
      }
    }
    el.querySelectorAll('[data-nui-option] input').forEach(function (input) {
      input.addEventListener('change', update);
    });
    update();
  });

  /* ---------- quantité ---------- */
  document.querySelectorAll('.nui-qty').forEach(function (qty) {
    var input = qty.querySelector('input');
    if (!input) return;
    var floor = parseInt(input.min, 10);
    if (isNaN(floor)) floor = 1;
    var btns = qty.querySelectorAll('button');
    if (btns[0]) btns[0].addEventListener('click', function () {
      input.value = Math.max(floor, (parseInt(input.value, 10) || floor) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (btns[1]) btns[1].addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 0) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------- panier : le bouton commander attend l'acceptation des CGV ---------- */
  var cgvCheck = document.getElementById('nui-cgv-check');
  var checkoutBtn = document.querySelector('[data-nui-checkout]');
  if (cgvCheck && checkoutBtn) {
    checkoutBtn.disabled = !cgvCheck.checked;
    cgvCheck.addEventListener('change', function () {
      checkoutBtn.disabled = !cgvCheck.checked;
    });
  }

  /* ---------- panier : toute modification de quantité se soumet seule ---------- */
  document.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
    input.addEventListener('change', function () {
      if (input.form) input.form.submit();
    });
  });

  /* ---------- menu mobile : Échap et clic extérieur le referment ---------- */
  var burger = document.querySelector('.nui-burger');
  if (burger) {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && burger.open) { burger.open = false; }
    });
    document.addEventListener('click', function (e) {
      if (burger.open && !burger.contains(e.target)) { burger.open = false; }
    });
  }

  /* ---------- panier volant + ajout sans quitter la page ---------- */
  var drawerEl = document.getElementById('nui-drawer');
  var veilEl = document.getElementById('nui-drawer-veil');
  if (drawerEl && veilEl && window.fetch) {
    var itemsEl = document.getElementById('nui-drawer-items');
    var footEl = document.getElementById('nui-drawer-foot');
    var emptyEl = document.getElementById('nui-drawer-empty');
    var totalEl = document.getElementById('nui-drawer-total');
    var closeBtn = document.getElementById('nui-drawer-close');
    var lastFocus = null;

    function fmt(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }

    function setCount(n) {
      document.querySelectorAll('.nui-cartlink').forEach(function (link) {
        var badge = link.querySelector('.nui-cartcount');
        if (n > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'nui-cartcount';
            link.appendChild(badge);
          }
          badge.textContent = n > 9 ? '9+' : n;
        } else if (badge) { badge.remove(); }
      });
    }

    function renderCart(cart) {
      itemsEl.textContent = '';
      var has = cart.items.length > 0;
      footEl.hidden = !has;
      emptyEl.hidden = has;
      cart.items.forEach(function (item) {
        var line = document.createElement('div');
        line.className = 'nui-drawer__line';

        var img = document.createElement('img');
        if (item.image) {
          img.src = item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=200';
        }
        img.alt = '';
        line.appendChild(img);

        var mid = document.createElement('div');
        var t = document.createElement('div'); t.className = 't'; t.textContent = item.product_title;
        mid.appendChild(t);
        if (item.variant_title && item.variant_title !== 'Default Title') {
          var v = document.createElement('div'); v.className = 'v'; v.textContent = item.variant_title;
          mid.appendChild(v);
        }
        var qty = document.createElement('div'); qty.className = 'nui-drawer__qty';
        function changeQty(newQty) {
          qty.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: newQty })
          }).then(function (r) { return r.json(); }).then(function (c) {
            setCount(c.item_count); renderCart(c);
          }).catch(function () { window.location.href = '/cart'; });
        }
        var minus = document.createElement('button');
        minus.type = 'button'; minus.textContent = '−';
        minus.setAttribute('aria-label', 'Réduire la quantité');
        minus.addEventListener('click', function () { changeQty(item.quantity - 1); });
        var num = document.createElement('span'); num.textContent = item.quantity;
        var plus = document.createElement('button');
        plus.type = 'button'; plus.textContent = '+';
        plus.setAttribute('aria-label', 'Augmenter la quantité');
        plus.addEventListener('click', function () { changeQty(item.quantity + 1); });
        qty.appendChild(minus); qty.appendChild(num); qty.appendChild(plus);
        mid.appendChild(qty);
        line.appendChild(mid);

        var right = document.createElement('div');
        var p = document.createElement('div'); p.className = 'p'; p.textContent = fmt(item.final_line_price);
        right.appendChild(p);
        var rm = document.createElement('button');
        rm.type = 'button'; rm.className = 'rm'; rm.textContent = 'Retirer';
        rm.addEventListener('click', function () {
          rm.disabled = true;
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          }).then(function (r) { return r.json(); }).then(function (c) {
            setCount(c.item_count); renderCart(c);
          }).catch(function () { window.location.href = '/cart'; });
        });
        right.appendChild(rm);
        line.appendChild(right);

        itemsEl.appendChild(line);
      });
      totalEl.textContent = fmt(cart.total_price);
    }

    function openDrawer() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        renderCart(cart); setCount(cart.item_count);
        lastFocus = document.activeElement;
        veilEl.hidden = false; drawerEl.hidden = false;
        void drawerEl.offsetWidth; /* force le rendu : la transition part même si l'onglet est en arrière-plan */
        veilEl.classList.add('is-open'); drawerEl.classList.add('is-open');
        root.classList.add('nui-noscroll');
        if (closeBtn) closeBtn.focus();
      }).catch(function () { window.location.href = '/cart'; });
    }
    function closeDrawer() {
      veilEl.classList.remove('is-open'); drawerEl.classList.remove('is-open');
      root.classList.remove('nui-noscroll');
      setTimeout(function () { veilEl.hidden = true; drawerEl.hidden = true; }, 400);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    veilEl.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawerEl.hidden) closeDrawer();
    });

    /* l'icône panier ouvre l'aperçu (sauf sur la page panier elle-même) */
    document.querySelectorAll('.nui-cartlink').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (window.location.pathname.indexOf('/cart') !== -1) return;
        e.preventDefault();
        openDrawer();
      });
    });

    /* ajout au panier : on reste sur la fiche, l'aperçu s'ouvre */
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var buttons = [];
        form.querySelectorAll('button[type="submit"]').forEach(function (b) { buttons.push(b); });
        if (form.id) {
          document.querySelectorAll('button[form="' + form.id + '"]').forEach(function (b) { buttons.push(b); });
        }
        var olds = buttons.map(function (b) { return b.textContent; });
        buttons.forEach(function (b) { b.disabled = true; b.textContent = 'Ajout…'; });
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('add');
            return r.json();
          })
          .then(function () {
            buttons.forEach(function (b, i) {
              b.disabled = false; b.textContent = 'Ajouté ✓';
              setTimeout(function () { b.textContent = olds[i]; }, 1600);
            });
            openDrawer();
          })
          .catch(function () { form.submit(); });
      });
    });
  }
})();
